var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 143,
    viewBox: "0 0 155 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.624367
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.653 0C122.643 0 126.694 3.68613 126.694 8.22613C126.694 12.7661 122.643 16.4523 117.653 16.4523C112.663 16.4523 108.612 12.7661 108.612 8.22613C108.612 3.68613 112.663 0 117.653 0Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5111 12.083C18.5028 12.083 21.7438 15.0319 21.7438 18.6639C21.7438 22.2959 18.5028 25.2448 14.5111 25.2448C10.5193 25.2448 7.27832 22.2959 7.27832 18.6639C7.27832 15.0319 10.5193 12.083 14.5111 12.083Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47199 102.979C13.4637 102.979 16.7047 105.928 16.7047 109.56C16.7047 113.192 13.4637 116.141 9.47199 116.141C5.48025 116.141 2.23926 113.192 2.23926 109.56C2.23926 105.928 5.48025 102.979 9.47199 102.979Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.258 95.9458C130.75 95.9458 133.586 98.5261 133.586 101.704C133.586 104.882 130.75 107.462 127.258 107.462C123.765 107.462 120.929 104.882 120.929 101.704C120.929 98.5261 123.765 95.9458 127.258 95.9458Z",
    fill: "#D7E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35914 75.3267C5.21305 75.3267 6.71828 76.6771 6.71828 78.3403C6.71828 80.0036 5.21305 81.354 3.35914 81.354C1.50523 81.354 0 80.0036 0 78.3403C0 76.6771 1.50523 75.3267 3.35914 75.3267Z",
    fill: "#E2B93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.207 51.2485C130.37 51.2485 132.126 52.824 132.126 54.7645C132.126 56.705 130.37 58.2805 128.207 58.2805C126.044 58.2805 124.288 56.705 124.288 54.7645C124.288 52.824 126.044 51.2485 128.207 51.2485Z",
    fill: "#E2B93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8642 3.5083C63.8726 3.5083 65.5032 4.97127 65.5032 6.77313C65.5032 8.57498 63.8726 10.038 61.8642 10.038C59.8558 10.038 58.2251 8.57498 58.2251 6.77313C58.2251 4.97127 59.8558 3.5083 61.8642 3.5083Z",
    fill: "#E2B93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3427 124.083C68.6601 124.083 70.5416 125.772 70.5416 127.851C70.5416 129.93 68.6601 131.618 66.3427 131.618C64.0253 131.618 62.1438 129.93 62.1438 127.851C62.1438 125.772 64.0253 124.083 66.3427 124.083Z",
    fill: "#E2B93B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.624367
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.368 60.6455L150.109 63.8803L154.003 64.399L151.186 66.9169L151.851 70.4723L148.368 68.7937L144.885 70.4723L145.55 66.9169L142.732 64.399L146.626 63.8803L148.368 60.6455Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77002 61.5278L10.8278 65.35L15.4292 65.963L12.0996 68.9381L12.8856 73.1391L8.77002 71.1557L4.65442 73.1391L5.44043 68.9381L2.11084 65.963L6.71222 65.35L8.77002 61.5278Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6674 4.30811L73.9884 6.76249L76.943 7.15572L74.8049 9.06584L75.3099 11.7633L72.6674 10.4894L70.025 11.7633L70.53 9.06584L68.3918 7.15572L71.3464 6.76249L72.6674 4.30811Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5503 130.906L79.6081 134.728L84.2095 135.341L80.8799 138.317L81.6659 142.518L77.5503 140.534L73.4347 142.518L74.2207 138.317L70.8911 135.341L75.4925 134.728L77.5503 130.906Z",
    fill: "#EB5757"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 27.3237C108.595 27.3237 131 49.7287 131 77.3237C131 104.919 108.595 127.324 81 127.324C53.405 127.324 31 104.919 31 77.3237C31 49.7287 53.405 27.3237 81 27.3237Z",
    fill: "#D7E0E2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPlaceholder);
export default __webpack_public_path__ + "static/media/success-placeholder.80dd2084889dc11d0643cf5cdae2b683.svg";
export { ForwardRef as ReactComponent };